<template>
  <section id="header" class="header fixed-top">
    <div class="bg-purple">
      <b-navbar class="main-navbar container" toggleable="lg" type="dark">
        <b-navbar-brand>
          <router-link tag="a" :to="{ name: 'index' }">
            <img src="@/assets/logo.svg" alt="Paxel" />
          </router-link>
        </b-navbar-brand>
        <b-navbar-toggle target="main-navbar-sidebar">
          <template #default="{ expanded }">
            <span v-if="!expanded" class="navbar-toggler-icon"></span>
            <span v-else></span>
          </template>
        </b-navbar-toggle>
        <b-collapse id="main-navbar-collapse" is-nav>
          <b-navbar-nav class="ml-auto" v-if="loggedIn">
            <b-nav-item :href="`#`">
              {{ loggedInName }}
            </b-nav-item>
            <b-nav-item :href="`#`" @click="onLogout">
              Log out
            </b-nav-item>
          </b-navbar-nav>
        </b-collapse>
        <b-sidebar
          id="main-navbar-sidebar"
          bg-variant="none"
          width="80%"
          text-variant="light"
          :no-header-close="!isTooglerShow"
          backdrop
          no-close-on-backdrop
          is-nav
          @change="changeToggler">
          <template slot="title">
            <router-link tag="a" :to="{ name: 'index' }">
              <img src="@/assets/logo.svg" alt="Paxel" height="30" />
            </router-link>
          </template>
          <template slot="header-close">
            <svg
              viewBox="0 0 16 16"
              width="1em"
              height="1em"
              focusable="false"
              role="img"
              aria-label="x"
              xmlns="http://www.w3.org/2000/svg"
              fill="currentColor"
              class="bi-x b-icon bi"
            >
              <g>
                <path
                  fill-rule="evenodd"
                  d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1
                  .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646
                  2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"
                ></path>
              </g>
            </svg>
          </template>
          <b-navbar-nav class="ml-auto" v-if="loggedIn">
            <b-nav-item :href="`#`">
              {{ loggedInName }}
            </b-nav-item>
            <b-nav-item :href="`#`">
              Log out
            </b-nav-item>
          </b-navbar-nav>
        </b-sidebar>
      </b-navbar>
    </div>
  </section>
</template>

<script>
import LocalStorage from '@/services/localstorage';

export default {
  name: 'Header',
  data() {
    return {
      isTooglerShow: false,
      isLogin: LocalStorage.getAuth() != null,
    };
  },
  methods: {
    scrollToAnchor() {
      this.$root.scrollToAnchor(this.$route.hash);
    },
    changeToggler(visible) {
      if (visible) {
        setTimeout(() => {
          this.isTooglerShow = true;
        }, 300);
      } else {
        this.isTooglerShow = false;
      }
    },
    onLogout() {
      this.$swal({
        title: 'Are you sure want to logout?',
        showCancelButton: true,
        confirmButtonText: 'Yes',
      }).then((result) => {
        if (result.value) {
          this.logout();
        }
      });
    },
    logout() {
      this.$store.dispatch('logout')
        .then(() => {
          this.$session.destroy();
          this.$router.push({ name: 'login' });
        });
    },
  },
  computed: {
    loggedIn() {
      return this.isLogin;
    },
    loggedInName() {
      return LocalStorage.getAuth() == null ? '' : JSON.parse(LocalStorage.getAuth()).name;
    },
  },
  created() {
    this.$store.watch(
      (state) => state.login,
      (newValue) => {
        this.isLogin = newValue.isLogin;
      },
    );
  },
};
</script>

<style scoped>
.main-navbar {
  font-family: 'GothamMedium';
  font-size: 14px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  padding: 22px 15px 18px 15px;
  height: 100%;
}
</style>
<style>
.header .dropdown-menu {
  top: 31px;
}
.header .dropdown-item {
  padding: 7px 20px 7px 20px;
}
.header .dropdown-toggle::after {
  vertical-align: .125em;
}

@media screen and (max-width: 1024px) {
  .navbar.main-navbar {
    font-family: 'GothamMedium';
    font-size: 14px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    height: 50px;
    padding: 10px 25px 10px 25px;
  }
}
</style>
